import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';

type Order = 'asc' | 'desc';

interface HeadCell {
    label: string;
    sortable?: boolean;
}

// Rows are grouped by ROI, so only Structure can be globally sorted; sorting
// other columns would silently reorder within groups and mislead clinicians.
const HEAD_CELLS: readonly HeadCell[] = [
    { label: 'Structure', sortable: true },
    { label: 'Type' },
    { label: 'Dose (Gy)' },
    { label: 'Volume (%)' },
    { label: 'a (gEUD)' },
    { label: 'Weight (a.u.)' },
];

export const COL_COUNT = HEAD_CELLS.length + 1; // +1 for expand column

interface ObjectivesTableHeadProps {
    order: Order;
    onToggleStructureSort: () => void;
}

const ObjectivesTableHead = ({
    order,
    onToggleStructureSort,
}: ObjectivesTableHeadProps) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell sx={{ width: 32, p: 0, borderBottom: 'none' }} />
                {HEAD_CELLS.map((cell) => (
                    <TableCell key={cell.label} align="left">
                        {cell.sortable ? (
                            <TableSortLabel
                                active
                                direction={order}
                                onClick={onToggleStructureSort}
                                sx={(theme) => ({
                                    color: `${theme.palette.primary.main}!important`,
                                    '& .MuiTableSortLabel-icon': {
                                        fontSize: 12,
                                        color: `${theme.palette.primary.main}!important`,
                                    },
                                })}
                            >
                                {cell.label}
                            </TableSortLabel>
                        ) : (
                            cell.label
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default ObjectivesTableHead;
